module.exports = __webpack_public_path__ + "img/daumen.6fa57506.jpg";